import { useState } from "react";
import Button from "../../../../../../components/Button/Button";
import styles from "./AppointmentDetailModal.module.scss";
import TextereaCustom from "../../../../../../components/TextareaCustom/TextareaCustom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";

const STATUS_LABELS = {
  pending: "En attente",
  confirmed: "Confirmé",
  cancelled: "Annulé",
};

const STATUS_COLORS = {
  pending: "#f0ad4e",
  confirmed: "#5bc0de",
  cancelled: "#c0392b",
};

function AppointmentDetailModal({
  appointment,
  isOpen,
  onClose,
  onConfirm,
  onCancel,
}) {
  const [showCancelForm, setShowCancelForm] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [cancelError, setCancelError] = useState("");

  if (!isOpen || !appointment) return null;

  const status = appointment.status || "pending";

  const handleCancelSubmit = () => {
    const trimmed = cancelReason.trim();
    if (!trimmed) {
      setCancelError("Le motif d'annulation est obligatoire.");
      return;
    }
    setCancelError("");
    onCancel(appointment.appointment_id, trimmed);
    setShowCancelForm(false);
    setCancelReason("");
  };

  const formattedDate = appointment.date
    ? new Date(appointment.date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : "Date non planifiée";

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Fermer"
        >
          ✕
        </button>

        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>
            Rendez-vous de {appointment.firstname} {appointment.lastname}
          </h3>
          <div className="d-flex flex-row align-items-center">
            <p className={styles.modalWeekday}>{formattedDate}</p>
            <p className={styles.modalTime}>
              {appointment.start_time?.slice(0, 5) ?? "—"} -{" "}
              {appointment.end_time?.slice(0, 5) ?? "—"}
            </p>
            <span
              className={styles.statusBadge}
              style={{
                backgroundColor: STATUS_COLORS[status] || "#999",
              }}
            >
              {STATUS_LABELS[status] || status}
            </span>
          </div>
        </div>

        <div className={styles.modalBody}>
          <p>
            <FontAwesomeIcon
              icon={faLocationDot}
              className={styles.contactIcon}
            />
            {appointment.address}
          </p>
          <p>
            <FontAwesomeIcon icon={faPhone} className={styles.contactIcon} />
            {appointment.phone_number}
          </p>

          <h4 className={styles.sectionLabel}>Prestations</h4>

          {appointment.prestations && appointment.prestations.length > 0 ? (
            <table className={styles.servicesTable}>
              <tbody>
                {appointment.prestations.map((item, index) => (
                  <tr key={index}>
                    <td>
                      {item.type} : {item.prestation}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className={styles.emptyServices}>
              Aucune prestation renseignée.
            </p>
          )}

          {status === "pending" && !showCancelForm && (
            <div className={styles.actions}>
              <Button
                color="var(--primary-color)"
                onClick={() => onConfirm(appointment.appointment_id)}
              >
                Confirmer
              </Button>
              <Button
                color="var(--secondary-color)"
                onClick={() => setShowCancelForm(true)}
              >
                Annuler le rendez-vous
              </Button>
            </div>
          )}

          {showCancelForm && (
            <div className={styles.cancelForm}>
              <label>Motif de l'annulation :</label>
              <TextereaCustom
                value={cancelReason}
                onChange={(e) => {
                  setCancelReason(e.target.value);
                  if (cancelError) setCancelError("");
                }}
                placeholder="Précisez la raison de l'annulation..."
              />
              {cancelError && <p className={styles.errorText}>{cancelError}</p>}
              <div className={styles.actions}>
                <Button
                  color="var(--primary-color)"
                  onClick={handleCancelSubmit}
                >
                  Envoyer l'annulation
                </Button>
                <Button
                  color="var(--secondary-color)"
                  onClick={() => {
                    setShowCancelForm(false);
                    setCancelError("");
                  }}
                >
                  Retour
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AppointmentDetailModal;
